import { ActionMenuItem, BaseActionEnum, BaseActions } from "../../components/action-menu/ActionMenuItem";
import { getActionMenuItems } from "../../components/action-menu/BaseActions";

export enum GaugeSheetActionEnum {
    GoTo = "goto"
}

export enum GaugeSheetSubActionEnum {
    GoToRunTicket = "runtickets",
    GoToTankBattery = "tankbatteries"
}

export type GaugeSheetActionItem = {
    action: GaugeSheetActionEnum | BaseActions | string;
    subAction?: GaugeSheetSubActionEnum;
    objectID?: number;
} & ActionMenuItem;


 const actionEnums = [
     BaseActionEnum.Export,
     BaseActionEnum.Refresh,
     BaseActionEnum.Favorite
];

export const actionItems = getActionMenuItems(actionEnums).map(o => {
    return {...o,
    } as GaugeSheetActionItem; 
});
